/**
 * Preset reactions. A small fixed set, never free text, so the game stays safe for
 * children without anyone having to moderate it. scope.md §8.3.
 *
 * Sent as ids rather than emoji, so the server validates against a closed list.
 */

export const REACTION_IDS = ['thumbsUp', 'laugh', 'wow', 'oops', 'clap', 'party'] as const;
export type ReactionId = (typeof REACTION_IDS)[number];

export const REACTION_EMOJI: Record<ReactionId, string> = {
  thumbsUp: '👍',
  laugh: '😂',
  wow: '😮',
  oops: '🙈',
  clap: '👏',
  party: '🎉',
};
